import { Container, Dialog, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useParams } from "react-router-dom";
import useAuth from "src/hooks/useAuth";
import Register from "src/pages/auth/Register";
import Emailmessage from "src/sections/auth/register/emailMessage";
import themes from "src/images/theme.png";
import "./style.css";
import bitstox from "src/images/bitstox-logo.png";
import { LoginForm } from "src/sections/auth/login";
import { Box } from "@material-ui/core";
import right from "src/images/rightOne.png";
import left from "src/images/left.png";
import BgCover from "src/images/bg1.jpg";
const Index = () => {
  const [open, setOpen] = useState(false);
  const [openRegister, setOpenRegister] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { user, isAdmin } = useAuth();
  const isLoggedIn = !user;

  const handleCloseRegister = () => {
    setOpenRegister(false);
  };
  const handleOpen = () => {
    setOpen(true);
    handleCloseRegister(true);
  };
  const handleClose = () => setOpen(false);

  const { uname } = useParams();

  useEffect(() => {
    if (uname) {
      setOpenRegister(true);
    }
  }, [uname]);
  const [emailMessage, setEmailMessage] = useState(false);
  const [openMessage, setOpenMessage] = useState();

  const handleClickOpenMessage = () => {
    setOpenMessage(true);
    setOpenRegister(false);
  };
  const handleCloseMessage = () => {
    setOpenMessage(false);
  };
  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleScroll = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  const [menuOpen, setMenuOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  const menuRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const currentYear = new Date().getFullYear();
  const isSubAdmin = localStorage.getItem("isSubAdmin") === "true";

  if (isSubAdmin) {
    const menu_lists = JSON.parse(localStorage.getItem("menu"));
    const [menu] = menu_lists;
    const { path, children } = menu?.items[0] || {};
    if (path.includes("dashboard")) {
      window.location = `${window.origin}${path}`;
      return;
    }
    window.location = `${window.origin}${path}`;
    return;
  }

  return (
    <>
      <Helmet>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Bitstox</title>
        <link rel="stylesheet" href="style.css" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <body
        className="banner bodyBox"
        style={{
          fontFamily: "'Montserrat', sans-serif",
          backgroundImage: `url(${BgCover})`,
          backgroundSize: "cover",
        }}
      >
        <nav className="navlanding" ref={menuRef}>
          <div className="containerox">
            <div>
              <img
                style={{ marginTop: isMobile ? "6%" : "30%" }}
                src={bitstox}
                alt="Logo"
              />
            </div>

            {/* Mobile Menu Toggle Button */}
            <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
              ☰
            </div>

            <div
              className={`nav-links ${menuOpen ? "open" : ""}`}
              style={{ marginTop: isMobile ? 2 : 20 }}
            >
              <ul>
                <li>SIP</li>
                <li>FIP</li>
                <li>Coupon</li>
                <li>Market</li>
                <li>Contact</li>

                {isLoggedIn ? (
                  <li
                    onClick={() => {
                      handleOpen();
                      setMenuOpen(false);
                    }}
                  >
                    Login
                  </li>
                ) : (
                  <>
                    {isAdmin ? (
                      <Link
                        onClick={() => setMenuOpen(false)}
                        to="/admin/dashboard/business"
                        className="nav-link loginBtn"
                      >
                        Dashboard
                      </Link>
                    ) : (
                      <Link
                        to="/user/dashboard"
                        onClick={() => setMenuOpen(false)}
                        className="nav-link loginBtn"
                      >
                        Dashboard
                      </Link>
                    )}
                  </>
                )}
              </ul>
            </div>
          </div>
        </nav>
        <div class="containerox mainarea">
          <Container>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              flexDirection={{ xs: "column", md: "row" }}
            >
              {/* Left Side - Typography Content */}

              <Box
                textAlign="left"
                sx={{
                  mt: { xs: -5, lg: -5 },
                  maxWidth: { xs: "100%", lg: "50%" },
                  mb: { xs: 3 },
                }}
              >
                <img style={{ marginLeft: "-50px" }} src={right} />

                <Typography fontSize={"45px"} sx={{ fontWeight: 800 }}>
                  Mind your affiliate
                </Typography>
                <Typography
                  variant="body2"
                  mt={3}
                  maxWidth={600}
                  lineHeight={2}
                  fontStyle="italic"
                >
                  At their core, cryptocurrencies are built around the principle
                  of a universal, inviolable ledger, one that is made fully
                  public and is constantly being verified by these high-powered
                  computers, each essentially acting independently of the
                  others.
                </Typography>
                <Box display="flex" alignItems="center">
                  <Typography variant="subtitle1" fontStyle="italic">
                    - Paul Vigna, Markets reporter for The Wall Street Journal
                  </Typography>
                  <img style={{ marginLeft: "-8px" }} src={left} alt="icon" />
                </Box>
              </Box>

              {/* Right Side - Info Container */}
              <div className="info-contanier">
                <h4 style={{ color: "white", fontWeight: 500 }}>
                  Affiliate with{" "}
                </h4>
                <h2 style={{ color: "white" }}>16 k+</h2>
                <div className="devider"></div>
                <h4 style={{ color: "white", fontWeight: 500 }}>Distributed</h4>
                <h2 style={{ color: "white" }}>21 + Countries</h2>
                <div className="devider"></div>
                <h4 style={{ color: "white", fontWeight: 500 }}>Partners</h4>
                <h2 style={{ color: "white" }}>12 k+</h2>
                <div className="devider"></div>
                <h4 style={{ color: "white", fontWeight: 500 }}>
                  Global Investors
                </h4>
                <h2 style={{ color: "white" }}>1.5 million+</h2>
              </div>
              <div class="bg-theme-1">
                {" "}
                <img
                  style={{
                    marginTop: 50,
                    marginLeft: -60,
                    opacity: 0.5,
                  }}
                  src={themes}
                />
              </div>
              <div class="bg-theme-2">
                <img src={themes} />
              </div>
            </Box>
          </Container>
        </div>
        <footer>
          <div class="container">
            <p>
              1061, Fort Evas Road, Site #137, Leesburg. VA 20176 <br />
              Toll free no. 1-800-Bitstox{" "}
            </p>
          </div>
          <div class="container mt-20">
            <p>Policy | Terms & conditions | Cookies </p>
            <p>copyright {currentYear} @ Bitstox.co </p>
            <p>
              Developed by{" "}
              <a
                style={{ color: "white", textDecoration: "none" }}
                href="https://zcodez.com/"
                target="_blank"
              >
                {" "}
                ZCODEZ,Inc.
              </a>
            </p>
          </div>
        </footer>
      </body>
      <Dialog open={openRegister} onClose={handleClose}>
        <Register
          setEmailMessage={setEmailMessage}
          message={handleClickOpenMessage}
          handleClickOpenLogin={handleOpen}
        />
      </Dialog>

      <Dialog open={open} onClose={handleClose}>
        <LoginForm handleCloseLogin={handleClose} />
      </Dialog>
      <Dialog
        className="overFlowModalemail"
        fullScreen={fullScreen}
        open={openMessage}
        onClose={handleCloseMessage}
      >
        <Emailmessage
          handleClose={handleClose}
          close={handleCloseMessage}
          emailMessage={emailMessage}
        />
      </Dialog>
    </>
  );
};

export default Index;
